import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Icon,
  Box,
  useColorModeValue,
  Heading,
} from '@chakra-ui/react';
import { FiStar, FiCalendar, FiDollarSign, FiClock } from 'react-icons/fi';

const BacReviewPopup = ({ isOpen, onClose, onInscrire }) => {
  const accentColor = 'blue.500';

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      size="xl" 
      isCentered 
      motionPreset="slideInBottom"
    >
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(10px)" />
      <ModalContent 
        dir="rtl" 
        textAlign="right" 
        borderRadius="2xl" 
        overflow="hidden"
        boxShadow="2xl"
      >
        <Box 
          bg={accentColor} 
          h="100px" 
          display="flex" 
          alignItems="center" 
          justifyContent="center"
          position="relative"
        >
          <Icon as={FiStar} w={12} h={12} color="white" />
          <ModalCloseButton color="white" left="8px" right="auto" />
        </Box>

        <ModalBody p={8}>
          <VStack spacing={6} align="stretch">
            <Heading size="lg" textAlign="center" color={accentColor}>
              إعلان هام لتلامذة البكالوريا
            </Heading>
            
            <Text fontSize="lg" lineHeight="1.8" fontWeight="medium">
              تعتزم كوبرا إديوكيشن إطلاق برنامج مراجعة خاص بالبكالوريا، يشمل 20 حصة بسعر 40 دينار فقط.
            </Text>

            <VStack spacing={4} align="stretch" bg="gray.50" p={6} borderRadius="xl" _dark={{ bg: 'gray.700' }}>
              <Box display="flex" alignItems="center">
                <Icon as={FiClock} ml={3} color={accentColor} />
                <Text fontWeight="bold">البرنامج: 20 حصة مراجعة شاملة</Text>
              </Box>
              <Box display="flex" alignItems="center">
                <Icon as={FiDollarSign} ml={3} color="green.500" />
                <Text fontWeight="bold">السعر: 40 دينار فقط</Text>
              </Box>
              <Box display="flex" alignItems="center">
                <Icon as={FiCalendar} ml={3} color="orange.500" />
                <Text fontWeight="bold">📅 آخر أجل للتسجيل: <Text as="span" color="red.500">06/05/2026</Text></Text>
              </Box>
            </VStack>

            <Text fontSize="md" color="gray.600" _dark={{ color: 'gray.400' }} textAlign="center">
              سارعوا بحجز أماكنكم للاستفادة من هذا العرض المميز والاستعداد الجيد للامتحان.
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter p={8} pt={0} display="flex" gap={4}>
          <Button 
            colorScheme="blue" 
            size="lg" 
            flex="1" 
            h="60px" 
            fontSize="xl"
            onClick={onInscrire}
            borderRadius="xl"
            _hover={{ transform: 'scale(1.02)' }}
            transition="all 0.2s"
          >
            سجل الآن
          </Button>
          <Button 
            variant="ghost" 
            size="lg" 
            onClick={onClose}
            borderRadius="xl"
          >
            إغلاق
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default BacReviewPopup;

